import i18n from '@monolith/legacy/services/i18n';
import { Collection, CollectionType } from './types';
import { AkLocale } from '@core/types/base';
import type { ESProductHit, ESBrandHit } from '@bc/discovery/domain/catalog';

import { ProductSearchService } from '../product';
import * as api from './api';

export const createCollectionSubtitle = (collection: Collection): string => {
  if ('product' in collection.counts) {
    const count = collection.counts.product;
    return Number.isInteger(count)
      ? i18n.global.tc('global.productsCount.lbl', count, {
          count,
        })
      : undefined;
  } else if ('brand' in collection.counts) {
    const count = collection.counts.brand;
    return Number.isInteger(count)
      ? i18n.global.tc('{count} Brand | {count} Brand | {count} Brands', count, {
          count,
        })
      : undefined;
  }

  return '';
};

export const createCollectionType = (collection: Collection): CollectionType => {
  if ('product' in collection.counts) {
    return CollectionType.Product;
  } else if ('brand' in collection.counts) {
    return CollectionType.Brand;
  }
  return undefined;
};

export const createCard = (collection: Collection) => ({
  title: collection.name,
  image: collection.image,
  subtitle: createCollectionSubtitle(collection),
  url: `/collection/${collection.reference}`,
  uuid: collection.uuid,
  collectionType: createCollectionType(collection),
  itemType: createCollectionType(collection),
});

export const getCollection = async (
  lang: AkLocale,
  collection: Collection,
  userCountry: string
): Promise<{ type: CollectionType; items: ESProductHit[] | ESBrandHit[] }> => {
  const collectionType = createCollectionType(collection);
  try {
    if (collectionType === CollectionType.Product) {
      const { results } = await ProductSearchService.searchProducts([
        { lang, userCountry, page: 0, hitsPerPage: 20, collectionId: collection.reference },
      ]);
      return {
        items: results.flatMap((result) => result.hits),
        type: CollectionType.Product,
      };
    } else if (collectionType === CollectionType.Brand) {
      return {
        items: await api.getBrandCollectionHits(lang, collection.reference, userCountry),
        type: CollectionType.Brand,
      };
    }
  } catch {
    // fail silently
  }

  return { items: undefined, type: undefined };
};
